import PropTypes from 'prop-types'

import CheckRow from './CheckRow'
import styles from './styles/CheckRowCount.css'

const CheckRowCount = ({ text, count, checked, toggle }) => {
  return (
    <div className={styles.sectionRow}>
      <CheckRow checked={checked} toggle={toggle}>
        {text}
      </CheckRow>
      <span>
        {count && <span>{count.toLocaleString()}</span>}
      </span>
    </div>
  )
}

CheckRowCount.propTypes = {
  checked: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  text: PropTypes.string,
  count: PropTypes.number
}

export default CheckRowCount
